import api from '../../plugins/api';

// ÐÐ°ÑÐºÐ° ÑÐ°Ð¹Ð»Ð¾Ð² ÑÑÐ¾Ð´Ð¸Ñ Ð¾Ð´Ð½Ð¸Ð¼ Ð·Ð°Ð¿ÑÐ¾ÑÐ¾Ð¼ â Ð±ÑÐº Ð¾Ð±ÑÐ°Ð±Ð°ÑÑÐ²Ð°ÐµÑ ÐµÑ ÐºÐ°Ðº Ð¾Ð´Ð¸Ð½ Ð»Ð¾Ð³Ð¸ÑÐµÑÐºÐ¸Ð¹
// Ð¸Ð¼Ð¿Ð¾ÑÑ: Ð·Ð°Ð¼ÐµÐ½Ð° ÑÐµÐ³Ð¼ÐµÐ½ÑÐ¾Ð² ÑÑÐ¾ÐºÐ° (ÐÐ¦ + Ð¼Ð°ÑÐºÐ°) Ð¾Ð±ÑÐ°Ñ Ð½Ð° Ð²ÑÐµ ÑÐ°Ð¹Ð»Ñ Ð¿Ð°ÑÐºÐ¸, Ð° Ð½Ðµ
// Ð¿Ð¾Ð²ÑÐ¾ÑÐ½Ð°Ñ Ð´Ð»Ñ ÐºÐ°Ð¶Ð´Ð¾Ð³Ð¾ (Ð¸Ð½Ð°ÑÐµ ÑÐ°Ð¹Ð»Ñ Ñ Ð¿ÐµÑÐµÑÐµÐºÐ°ÑÑÐ¸Ð¼Ð¸ÑÑ ÐÐ¦+Ð¼Ð°ÑÐºÐ¾Ð¹ Ð·Ð°ÑÐ¸ÑÐ°Ð»Ð¸ Ð±Ñ
// Ð´ÑÑÐ³ Ð´ÑÑÐ³Ð°)
const uploadStock = (files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));

  return api.post('/api/crm/cars/uploadStock', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export default uploadStock;
